export default {
    adminTest: [
      "HSt6S2N9qHaG4sR2Uy6pYTMng123"
    ],
    class2024: [
      "lUv1BvtncyNAjCDh2S7T4cBYo5Z2",
      "k6or1wxKfMWjLNbcuayn1GiiVK92",
      "c3ErGCRtgOWvhXXa4jmASP9pEFE3",
      "GOppefS5r8OK7wNUddjplHaM2q62",
      "T7tznxHd1rPBJOrYjxQnQ4b97Oa2",
      "jhqujCqsMha2ms7fveP5ytJTqZI3",
      "3BdTnraSWhNz4ghWr9wG59QESNx2",
      "DYiFGwjC7dhiagQ8cnImKBV6K3c2",
      "4sUCWPfKbyfAYo8jhSaT1rRwdwo2",
      "bgGKS66ndaUSWHhypcx1daC7x2q2",
      "0SKZzKvcXUfxh7WbPZNO1euVyDi1",
      "lmLsJIlB6ZWYVFXL9L3gODLLOfT2",
      "bfUrCffgYqStOEbDDtWXzczL7kH3",
      "044g9LiUu0fIqm7gaMfoedTVLML2",
      "jTSAawdU4rbTJ9mUAaNd2TTbCm92",
      "UvnYTLIuKxMBvQvtlSjy1IHCjGo2",
      "2NAFdThDB2X9vZ6ySDIZ4Wx1oJn1",
      "QZFoVvCShhZH8Lo6Vb7bbh51nWQ2",
      "McwPvMBcGnfGJsmLFmscm9Wlpe73",
      "nqZigdxiPNbvdxdN6Y6eMtR0vv42",
      "BVjruPSHG2VMrMOk9QxQHEdtHR52",
      "Q43wgOshKfORKkk8Acky7PZY5zW2",
      "26VgTafRbicTwtUwnC89mR5T2pA2",
      "lGGE4mCNdDgpSs8Iw9NFsxDo8GJ3",
      "0RP0vuIAa7PgoMVCwDU72ed9VOj2",
      "81pK068GFwaYlaqXDhGLc7l4eTD2",
      "zbzSp5Ob7efHU7iLWKhd9a0XmoG3",
      "JeGWdCZwslbGdxaMZqbQr3HGwFa2",
      "i9Km4GfxzSSgnSVGuvRJ62b3KV72",
      "34pErH6c4wPGZStuwgmrC6wPnjS2",
      "JefgzLlsnEd7kd3FI2Ja8YS5K533",
      "cIXZXxBkk9bt0T82NFUGERMLSBH3",
      "vUl7Xu8V9jboWg1NjqwOtsANmee2",
      "2Ae8CER95KYZTPPof5O4QvhWod52",
      "Yu3Oi3KdO4VXXGRJ8LN9NKeZvij1",
      "Bm5j6v9JnGPz3UMmNWZab9iBr1j1",
      "vLgqvbA13palhe5dvvIzHbVARXA2",
      "mBxINAHQVXeAEQFAg1zLKIfJov92",
      "Gv7HvD8foXRbZuR7fSpdo7macEm2",
      "TYXXC0gNnHdd5mV81tKdq4gHibm1",
      "bxtcY3aVlPQcfpN3JhOh19oy1kM2",
      "81otnaWE4XSt22nYTBCquyVsmWZ2",
      "vlBjpFPAZ7R1WP67hl2CpMl7m6y1",
      "gOK9uCiB24SqV68DsTZEAjfJakl1",
      "sR7uhgHUINaVquSyU5RaYIz3a2c2",
      "FOndam4UkxdV0p0grQKvB4AmSTj1",
      "qJC3mRW5xyalk1WuJIsGgyBaZWG2",
      "TJum2xlR2VfjVpZx7KPBmWlLT6w1",
      "ScBSPRzeO8P08eIvpIYDPrfAzY33",
      "tnXVYojAgfYxtfexfqQakDU3ee13",
      "S4g2zl4qbRULArp4xXl5ebp0pkr1",
      "wWUtcVLdOjflTfeL3sKVcz3xF1S2",
      "SQBAqnrdXicoBUa4U4NlSO9EDPA2",
      "aWYRpOc2BCO2Kr02qACG5Bw3R1Y2",
      "9LObE9RvamRo1roap6ACmA1phg23",
      "M472XThgxycN4VK6ERSmG15knNx2",
      "TKl9MhReYaZWEEW8FNgHqKNxkYn1",
      "Vi74nMPWLcMcr0p2XCwwbQiRr0q2",
      "z3IMGd0VnXeWRGS2cENEPGMCNtm1",
      "PxYvY9XmrnWfcDiNYkW5PdIoilm1",
      "cqmvM6oz7rcFydG9Hl1nVrxARdn2",
      "mDSulRDvVySkechxoXZnlQaRGYF3",
      "JTUFgLEOtigtibLGkaDKXYjUgNJ2",
      "2Sts2LLmD8Ty4TR6rD9uYQ0t1Rf2",
      "uWY9u9ITAqgOjkXz09PZi7PPYjB3",
      "njLys1eD4kOpyrx2i0oopcnLRYF2",
      "bTFt26aLdObiRE5JAkcdmTKybwF2",
      "yil1AN3s0PVFOl8AO5cGoyPieLZ2",
      "0tV6j8ALmLeBgZP8N6TfFk8KkQg1",
      "zXt6fjbl0eUbKsRU6lYL9HMNFKe2",
      "B5wMos3UwxgSLJgnohdZdU6JzlC3",
      "EcOlrA6pFeRjkVbTt8q3jYBwut22",
      "0vZgEgrp5ghQu3HHqOJIIZj5QHy2",
      "sjbYwtvMZKfCVtVr0RhiY6bEf1A3",
      "suydXQgsa5XLHhKB1Vwc2URtJqV2",
      "G4HafrkofQYFZIroIyIC5oyRzhk1",
      "8TNOKTTIBdVE9uDvKbT7ME7ZckG2",
      "Lhrf0rGuUhYEDEdkInvRo4pVvkn2",
      "Wqd4ZihoZNc8PZkOpmq6WUJAdlE3",
      "mH1aKavNKUhJ38pU2ZDka2KgrtK2",
      "Ptelz3cE4xcUhikOC2TEq5f7kvP2",
      "ok3QgoJVETfpM7Coqj4Dnikaf5Q2",
      "zpAYQZInuPN5oychF77colufGL63",
      "AoLth71q9RgbusgZiWXKO0FW5z83",
      "Hw6EMWB2bTOgF8Fx80YweeW3uh62",
      "qcAEaAw9qwbliwQmQmXwwJbzplK2",
      "Zf9jRCl8JaWsfMjd86yY3aBgRzp2",
      "swwMusYFU8ghodw2rheixkqr4Ee2",
      "eXicnngCa9RGSXKZ4MjweGGlrhr1",
      "rRCxLPsnNvYc9I8Lyhtgcdx5N6t2",
      "vvC8ThJoTYMN62ZKRj2dGn7vkG53",
      "5f1w9FQw9yak6Q36mEaBYKKymO83",
      "CJXNsuZ9rVQVzojzrPpAegNXNm52",
      "iA20SR72lPP7ktbZFfo7L8noe4X2",
      "sbrYS5ynWAP55fHWtx1UDe1VwUe2",
      "XfY9oKeUVwQ8uqhsLBcEXPFkWGg2",
      "EshkelXmYAfVXTw8tpde8n71a5j2",
      "ZemcPAtZBAcX4ZGcLvB15a363Ui2",
      "OCFiEcTcRocL1aiIyy7yWqKLwgI2",
      "FKMKtmK9gvOr1i8G4rWOZDLkRVo2",
      "hbcWSJmApShLqK3dMeNiysT3yBG3",
      "RVdL5M9ZfCPzvtjHr9KUJcZ0VNU2",
      "sYT9Nrk1rvfT9ZVHQMpq0ThoSL43",
      "n43vtEgyASW7GBoUwaKr8Eom8pb2",
      "0sg78tyOHWUPwnOo4hdAtKdpF6A2",
      "DoZugdWgloQ7Mbl3m9IYq11SLDe2",
      "CFNzB0cTV9ZRGkwMs1kHbb2epfl2",
      "REc1eor9QFRpdhqjtRm95V7EmyW2",
      "JuRSM1Pdy4eEPyMM77Q3JE9yh2d2",
      "mcVJpYDKT5hhxMLBaPzHqcPup9d2",
      "82omisJoiwhAoaP2jo0T5Lqur4n2",
      "6Ka6QfDuQVU0adtlx5iX8hbvsTj1",
      "MuvKIDPtqQdHRJCPf1QJ1kQbbfi2",
      "J8uoxheTdUexYr1T3FQwMQWt7K03",
      "H2dnysh0JvZWDPObL8rU13Zzae92",
      "zcSNNn5DvMX5cejn13WLY9QYCRF3",
      "aFKBYaNCm6ONqrAyOI8skZImJR23",
      "ViaTImY6YIgTuVeWW8ZiRytATuh1",
      "qOAi4erDUEVsY56NoizgvTX6sw53",
      "SUUFO4xfXaQN1QRPZTmLhtKd3QF3",
      "7LEyLfe13aUtdqAVIoIOgjQtkwz2",
      "1nd6chztSie0kl0mzdV83dwBkmp2",
    ]
}
